//c2-home u2-components
export const fullName = "Dmitry Korotayev"
export const description = "I'm creative employee based in Minsk, and I'm very passionate and dedicated to my work."
export const nickName = "DmitryKRTV"

//c3-about component
export const aboutDescription = "I'm Frontend developer and I create web applications using React/Redux with responsive interface."

//c8-contact component
export const email = "dmitry.korotayev@gmail.com"
export const emailHref = "mailto:dmitry.korotayev@gmail.com?subject=Write%20the%20topic&body=%0A%0AFull%20name:%0APhone%20number:"

export const skype = "Dmitry Korotaev"
export const skypeHref = "https://join.skype.com/invite/EHpHxaQWmdTd"

export const telegram = "dmitryKorotaev"
export const telegramHref = "https://t.me/dmitryKorotaev"

export const instagram = "vahkrasavcheg"
export const instagramHref = "https://www.instagram.com/vahkrasavcheg/"


